var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "form-row" }, [
    _c("div", { staticClass: "form-group col-md-4" }, [
      _c("div", { staticClass: "form-check" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.notifyPublicLink,
              expression: "notifyPublicLink"
            }
          ],
          staticClass: "form-check-input",
          attrs: { id: _vm.uid + "_notifyPublicLink", type: "checkbox" },
          domProps: {
            checked: Array.isArray(_vm.notifyPublicLink)
              ? _vm._i(_vm.notifyPublicLink, null) > -1
              : _vm.notifyPublicLink
          },
          on: {
            change: function($event) {
              var $$a = _vm.notifyPublicLink,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.notifyPublicLink = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.notifyPublicLink = $$a
                      .slice(0, $$i)
                      .concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.notifyPublicLink = $$c
              }
            }
          }
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "form-check-label",
            attrs: { for: _vm.uid + "_notifyPublicLink" }
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.$t(
                    "workflow.vueFormBuilder.elements.text.model.notifyPublicLinkEnabled"
                  )
                ) +
                "\n      "
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }